<template>
    <div>
        <masternav/>
        <b-container class="mt-5" v-if="perfil.UniKey == 0">
            <br><br>
            <b-alert
                :show="dismissCountDown"
                dismissible
                variant="warning"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                    <p v-if="$i18n.locale == 'es'">{{messages.es}}</p>
                    <p v-else>{{messages.en}}</p>
                </b-alert>
            <h1 class="titlequestion ml-5 mr-5 text-center text-uppercase">Formulario Registro</h1>
            <div class="ml-5 mr-5 navtext2 text-center">
          <h5>
            {{$t('contact_comp.message')}}
          </h5>
        </div>
            <b-row>
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col lg="3">
                                <b-form-group label="Contrato(no add)" label-for="contrato" description="">
                                    <b-form-input id="contrato" type="number" required placeholder="" v-model="form.contrato">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group label="Cédula" label-for="ced" description="">
                                    <b-form-input id="ced" type="text" required placeholder="" v-model="form.cedula">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group label="Apellido" label-for="apellido" description="">
                                    <b-form-input id="apellido" type="text" required placeholder="" v-model="form.apellido">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                    <b-button block squared class="button" @click="buscar" :disabled="spinner">
                                        <span v-if="spinner">procesando...<b-spinner small label="Small Spinner"></b-spinner></span>
                                        <span v-else>Buscar Cliente</span>
                                    </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <b-container class="mt-5" v-else>
            <b-alert
                :show="dismissCountDown"
                dismissible
                variant="warning"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                    <p v-if="$i18n.locale == 'es'">{{messages.es}}</p>
                    <p v-else>{{messages.en}}</p>
            </b-alert>

            <h1 class="titlequestion ml-5 mr-5 text-center text-uppercase">Completar Registro</h1>
            <div class="ml-5 mr-5 navtext2 text-center">
          <h5>
            {{$t('formulario_registro.subtittle')}}
          </h5>
        </div>
            <b-row>
                <b-col>
                    <b-card>
                        <b-form @submit.prevent="signUp">
                        <b-row>
                            <b-col lg="3">
                                <b-form-group label="Nombre(*)" label-for="nombre" description="">
                                    <b-form-input :state="validarNombre" id="nombre" type="text" placeholder="" v-model="perfil.Nombre">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group label="Segundo Nombre" label-for="n2" description="">
                                        <b-form-input id="n2" type="text" placeholder="" v-model="perfil.segundo_nombre">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group label="Apellido Paterno(*)" label-for="apellido" description="">
                                        <b-form-input id="apellido" :state="validarApellidoParterno" type="text" required placeholder="" v-model="perfil.Apellido">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group label="Apellido Materno" label-for="apellido_materno" description="">
                                        <b-form-input id="apellido_materno" type="text" placeholder="" v-model="perfil.NombreII">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            
                            <!-- <b-col lg="3">
                                <b-form-group label="Fecha de Nacimiento" label-for="fecnac" description="">
                                    <b-form-input id="fecnac" type="date" required placeholder="" v-model="perfil.FecNac">
                                    </b-form-input>
                                </b-form-group>
                            </b-col> -->
                        </b-row>
                        <b-row>
                            <b-col lg="4">
                                <b-form-group label="Cédula" label-for="cedula(*)" description="">
                                    <b-form-input id="cedula" type="text" :state="validarCedula" required placeholder="" v-model="perfil.Cedula">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4">
                                    <b-form-group label="Cédula País(*)" label-for="cedPais" description="">
                                    <b-form-input id="cedPais" type="text" :state="validarCedulaPais" required placeholder="" v-model="perfil.CedPais">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4">
                                <b-form-group label="Fecha de Nacimiento(*)" label-for="fecnac" description="">
                                    <b-form-input id="fecnac" type="date" required placeholder="" :state="validarCedulaVenc" v-model="perfil.FecNac">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="4">
                                <b-form-group label="Licencia(*)" label-for="licencia" description="">
                                    <b-form-input id="licencia" type="text" required placeholder="" :state="validarLicencia" v-model="perfil.Licencia">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4">
                                    <b-form-group label="Vencimiento Licencia(*)" label-for="venceLic" description="">
                                    <b-form-input id="venceLic" type="text" required placeholder="" v-mask="'##/##'" :state="validarVenceLicencia" v-model="perfil.LicVence">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4">
                                    <b-form-group label="País(*)" label-for="licpais" description="">
                                    <b-form-input id="licpais" type="text" required placeholder="" :state="validarLicenciaPais" v-model="perfil.Pais">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            
                        </b-row>

                        <br>
                        <h2>Información Laboral</h2>
                        <hr>
                        <b-row>
                            <b-col lg="4">
                                <b-form-group label="Compañia(*)" label-for="company" description="">
                                    <b-form-input id="company" type="text" required placeholder="" :state="validarTrabajo" v-model="perfil.Compania">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4">
                                    <b-form-group label="Teléfono Compañia" label-for="telcom" description="">
                                    <b-form-input id="telcom" type="text" required placeholder="" :state="validarTelTrabajo" v-model="perfil.TelCia" v-mask="'###-####'">
                                    </b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col lg="4">
                                    <b-form-group label="Celular" label-for="cel" description="">
                                    <b-form-input id="cel" type="text" placeholder="" v-model="perfil.Celular">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            
                        </b-row>
                        <br>
                        <h2>Dirección Permanente</h2>
                        <hr>
                        <b-row>
                            
                                <b-col lg="4">
                                    <b-form-group label="País" label-for="pais" description="">
                                    <b-form-input id="pais" type="text" required placeholder="" v-model="perfil.PerPais">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>

                                <b-col lg="4">
                                    <b-form-group label="Ciudad" label-for="ciudad" description="">
                                        <b-form-input id="ciudad" type="text" required placeholder="" v-model="perfil.PerCiudad">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>

                                <b-col lg="4">
                                <b-form-group label="Barrio" label-for="barrio" description="">
                                    <b-form-input id="barrio" type="text" required placeholder="" v-model="perfil.PerBarrio">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>

                            <b-col lg="4">
                                <b-form-group label="Calle #" label-for="calle" description="">
                                    <b-form-input id="calle" type="text" required placeholder="" v-model="perfil.PerCalle">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                            <b-col lg="4">
                                        <b-form-group label="Casa #" label-for="casa" description="">
                                        <b-form-input id="casa" type="text" required placeholder="" v-model="perfil.PerCasa">
                                        </b-form-input>
                                    </b-form-group>
                            </b-col>
                            
                            
                            <b-col lg="4">
                                    <b-form-group label="Teléfono" label-for="tel" description="">
                                    <b-form-input id="tel" type="text" required placeholder="" v-model="perfil.PerTel">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                                
                        </b-row>
                        <br>
                        <h2>Credenciales para completar registro</h2>
                        <hr>
                        <b-row>

                            <b-col lg="4">
                                <b-form-group label="Email" label-for="email" description="">
                                    <b-form-input id="email" type="email" required placeholder="" v-model="perfil.email" :value="perfil.email = emailToLowerCase">
                                    </b-form-input>
                                    </b-form-group>
                                </b-col>
                            <b-col lg="4">
                                        <b-form-group label="Contraseña" label-for="pass" description="">
                                        <b-form-input id="pass" type="password" required placeholder="" v-model="perfil.password">
                                        </b-form-input>
                                    </b-form-group>
                            </b-col>
                            
                            <b-col lg="4">
                                    <b-form-group label="Confirmar Contraseña" label-for="pass_confirmation" description="">
                                    <b-form-input id="pass_confirmation" type="password" required placeholder="" v-model="perfil.password_confirmation">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                                
                        </b-row>

                        <b-row>

                            <b-col lg="12">
                                    <b-btn block squared class="button2" type="submit" :disabled="spinner">
                                        <span v-if="spinner">procesando...<b-spinner small label="Small Spinner"></b-spinner></span>
                                        <span v-else>Completar Registro</span>
                                    </b-btn>
                            </b-col>
                                
                        </b-row>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <br><br>
        <contactcomp/>
        <mainfooter/>
    </div>
</template>

<script>
import masternav from '@/components/masternav.vue'
import Mainfooter from '../components/mainfooter.vue'
import Contactcomp from '../components/contactcomp.vue'
import axios from 'axios'
import { mapState } from 'vuex'
    export default {
        components: {
            masternav,
            Mainfooter,
            Contactcomp
        },
        mounted () {
            if (!this.modoClientes) {
                this.$router.push('/')
            };
        },
        data() {
            return {
                form: {
                    cedula:'B01957355',
                    contrato:6900181,
                    apellido:'Alvarado',
                },
                dismissSecs: 7,
                dismissCountDown: 0,
                messages:{},
                perfil:{
                    UniKey:0,
                    TipoCte:'',
                    Nombre:'',
                    segundo_nombre:'',
                    Apellido:'',
                    NombreII:'',
                    Cedula:'',
                    CedPais:'',
                    FecNac:'',
                    Licencia:'',
                    LicVence:'',
                    Pais:'',
                    Compania:'',
                    TelCia:'',
                    Celular:'',
                    PerPais:'',
                    PerCiudad:'',
                    PerBarrio:'',
                    PerCalle:'',
                    PerCasa:'',
                    PerTel:'',
                    email:'',
                    password:'',
                    password_confirmation:'', 
                    brand  :  3
                },
                errors:{
                    nombre:false
                },
                spinner:false
            }
        },
        computed: {
            emailToLowerCase() {
                let email = this.perfil.email
                return email.toLowerCase()
            },
            validarNombre() {
                return this.perfil.Nombre.length > 4 && this.perfil.Nombre.length < 50
            },
            validarApellidoParterno() {
                return this.perfil.Apellido.length > 4 && this.perfil.Apellido.length < 50
            },
            validarCedula() {
                return this.perfil.Cedula.length > 4 && this.perfil.Cedula.length < 25
            },
            validarCedulaPais() {
                return this.perfil.CedPais.length > 4 && this.perfil.CedPais.length < 25
            },
            validarCedulaVenc() {
                return this.perfil.FecNac.length > 4 && this.perfil.FecNac.length < 25
            },
            validarLicencia() {
                return this.perfil.Licencia.length > 4 && this.perfil.Licencia.length < 20
            },
            validarLicenciaPais() {
                return this.perfil.Pais.length > 4 && this.perfil.Pais.length < 20
            },
            validarVenceLicencia() {
                return this.perfil.LicVence.length > 4 
            },
            validarTrabajo(){
                return this.perfil.Compania.length > 4 && this.perfil.Compania.length < 100
            },
            validarTelTrabajo(){
                return this.perfil.TelCia.length > 7 && this.perfil.TelCia.length < 20
            },
            ...mapState('autenticacion', ['modoClientes'])
        },
        methods: { 
            // buscar cliente        
            buscar() {
                if(this.form.cedula == null || this.form.contrato == null || this.form.apellido == null){
                    alert("todos los campos son requeridos")
                }else{
                    this.spinner = !this.spinner
                    axios.post('buscar-cliente', this.form).then(resp=>{
                        if(resp.data.accion == 3 || resp.data.accion == 1 || resp.data.accion == 0){
                            this.messages = resp.data
                            this.showAlert()
                            this.form = {}
                            this.spinner = !this.spinner
                        }else{
                            this.perfil = resp.data.perfil
                            console.log(resp.data.perfil);
                            this.spinner = !this.spinner
                        }
                    }) 
                }
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            signUp(){
                this.spinner = !this.spinner
                axios.post('almacenar-cliente', {
                    'id'                    :  this.perfil.UniKey,
                    'tipo_cliente'          :  this.perfil.TipoCte,
                    'nombre'                :  this.perfil.Nombre,
                    'segundo_nombre'        :  this.perfil.segundo_nombre,
                    'apellido_paterno'      :  this.perfil.Apellido,
                    'apellido_materno'      :  this.perfil.NombreII,
                    'cedula'                :  this.perfil.Cedula,
                    'ced_pais'              :  this.perfil.CedPais,
                    'fecha_nacimiento'      :  this.perfil.FecNac,
                    'num_licencia'          :  this.perfil.Licencia,
                    'vence_licencia'        :  this.perfil.LicVence,
                    'licencia_pais'         :  this.perfil.Pais,
                    'trabajo'               :  this.perfil.Compania,
                    'telefono_trabajo'      :  this.perfil.TelCia,
                    'cel_trabajo'           :  this.perfil.Celular,
                    'pais'                  :  this.perfil.PerPais,
                    'ciudad'                :  this.perfil.PerCiudad,
                    'barrio'                :  this.perfil.PerBarrio,
                    'calle'                 :  this.perfil.PerCalle,
                    'casa'                  :  this.perfil.PerCasa,
                    'telefono'              :  this.perfil.PerTel,
                    'email'                 :  this.perfil.email,
                    'password'              :  this.perfil.password,
                    'password_confirmation' :  this.perfil.password_confirmation, 
                    'brand'                 :  3
                }).then(resp=>{
                    this.messages = resp.data
                    this.showMessageSuccess()
                    this.errors = {}
                    this.spinner = !this.spinner
                }).catch(e=>{
                    this.spinner = !this.spinner
                    if (e.response.data.errors.nombre) {
                        this.errors.nombre = true
                    }
                })
            },
            showMessageSuccess() {

                    this.$bvModal.msgBoxOk(this.messages.es, {
                        title: 'Confirmado',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true,
                        noCloseOnBackdrop: true,
                        noCloseOnEsc: true
                    })
                    .then(value => {
                        
                        this.$router.push({name: 'Home'})
                        
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
.form-control {
    border-radius: 0;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  border: none;
  margin-top: 13%;
}
.button2{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  border: none;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}

</style>